<template>
<div class="fondo">
<section class="center">
    <article>
        <h1 class="header">404</h1>
    </article>
    <article>
        <p>Página no encontrada,
            <br> la página que estas buscando fue movida, removida, renombrada o nunca existió.</p>
    </article>
    <article>
        <form action="">
            <a href="/#" class="srchBtn">Regresar</a>
        </form>
    </article>
</section>  
</div>
</template>

<script>
export default {

}
</script>

<style  scoped>
    .fondo {
        background-color: #46AAB5;
        color: #fff;
        height: 100%;
        font-family: "Roboto", Calibri, Candara, Arial, sans-serif;
        font-size: 20px;
        line-height: 1.42857143;
        text-align: center;
    }

    a {
        color: #75C6D9;
        text-decoration: none;
        font: "Roboto", Calibri, Candara, Arial, sans-serif;
    }

    h3 {
        margin-bottom: 1%;
    }

    .srchBtn {
        border: 0;
        border-radius: 7px;
        padding: 0 17px;
        background: #904BB2;
        color: #fff;
        height: 65px;
        font-size: 1.5rem;
        cursor: pointer;
        font: "Roboto", Calibri, Candara, Arial, sans-serif;
    }

    .srchBtn:active {
        border-bottom: 0px solid #c0392b;
    }

    .srchBtn:focus {
        outline: 0;
    }

    .srchFld {
        border: 0;
        border-radius: 7px;
        padding: 0 17px;
        max-width: 404px;
        width: 40%;
        border-bottom: 5px solid #bdc3c7;
        height: 60px;
        color: #7f8c8d;
        font-size: 19px;
    }

    .srchFld:focus {
        outline-color: rgba(255, 255, 255, 0);
    }

    /* 404 Styling */

    .header {
        font-size: 13rem;
        font-weight: 700;
        margin: 2% 0 2% 0;
        text-shadow: 0px 3px 0px #7f8c8d;
    }

    .error {
        margin: -70px 0 2% 0;
        font-size: 7.4rem;
        text-shadow: 0px 3px 0px #7f8c8d;
        font-weight: 100;
    }

    .srchBtn:hover {
        background-color: #75C6D9;
    }
</style>